import {
  FETCH_ROOM_TYPES_REQUEST,
  FETCH_ROOM_TYPES_SUCCESS,
  FETCH_ROOM_TYPES_FAILURE,
  ADD_ROOM_TYPE_REQUEST,
  ADD_ROOM_TYPE_SUCCESS,
  ADD_ROOM_TYPE_FAILURE,
  UPDATE_ROOM_TYPE_REQUEST,
  UPDATE_ROOM_TYPE_SUCCESS,
  UPDATE_ROOM_TYPE_FAILURE,
  DELETE_ROOM_TYPE_REQUEST,
  DELETE_ROOM_TYPE_SUCCESS,
  DELETE_ROOM_TYPE_FAILURE,
} from '../action/roomTypeActions';

const initialState = {
  data: [],  // Menggunakan data
  loading: false,
  error: null,
};

const roomTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ROOM_TYPES_REQUEST:
      return { ...state, loading: true };
    case FETCH_ROOM_TYPES_SUCCESS:
      return { ...state, loading: false, data: action.payload }; // Ganti roomTypes dengan data
    case FETCH_ROOM_TYPES_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case ADD_ROOM_TYPE_REQUEST:
      return { ...state, loading: true };
    case ADD_ROOM_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...state.data, action.payload], // Ganti roomTypes dengan data
      };
    case ADD_ROOM_TYPE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case UPDATE_ROOM_TYPE_REQUEST:
      return { ...state, loading: true };
    case UPDATE_ROOM_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data.map((roomType) =>
          roomType.id === action.payload.id ? action.payload : roomType // Ganti roomTypes dengan data
        ),
      };
    case UPDATE_ROOM_TYPE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case DELETE_ROOM_TYPE_REQUEST:
      return { ...state, loading: true };
    case DELETE_ROOM_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data.filter((roomType) => roomType.id !== action.payload), // Ganti roomTypes dengan data
      };
    case DELETE_ROOM_TYPE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default roomTypeReducer;
